'use client'

import { PaymentProvider, usePayment } from '@/context/payment';
import dynamic from 'next/dynamic';
import React from "react";
import PaymentTitleCard from "@/components/widgets/payment-title-card";
import { useTranslations } from 'next-intl';
const PageContainer = dynamic(() => import('@/components/common/page-container'), { ssr: false });
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
import '@/components/styles/payments_common.scss';
import '@/components/styles/common.scss';
import '@/components/styles/common-payments.scss';

function LayoutContent({ children }: { children: React.ReactNode }) {
    const tPay = useTranslations('payments.payment_banner');
    const { activeTab } = usePayment();

    return (
        <PageContainer
            className='flex flex-col gap-8 pt-8'
        >
            <PaymentTitleCard
                image={
                    <Image
                        url={'/proud.svg'}
                        alt="icon"
                        className="w-[100px]"
                    />
                }
                title={tPay('title',{ name: activeTab })}
                description={tPay('description',{ name: activeTab.charAt(0).toUpperCase() + activeTab.slice(1) })}
            />
            {children}
        </PageContainer>
    );
}

export default function RootLayout({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) {
    return (
        <PaymentProvider>
            <LayoutContent>{children}</LayoutContent>
        </PaymentProvider>
    );
}
